module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.isShow
    }
  }, [(_vm.mask) ? _c('masks', {
    attrs: {
      "mshow": _vm.isShow,
      "mopacity": _vm.mOpacity
    },
    on: {
      "maskTap": _vm.maskTap
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "beast_slider",
    class: [_vm.mfrom, {
      beast_slide_from_reset: _vm.isShow
    }, _vm.slidecls],
    style: ({
      'z-index': _vm.zIndex,
      height: _vm.height
    })
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565e4d92"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/slide/index.vue
// module id = 64
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 68 69